import { useContext, useState } from 'react';
import { List, ListItemButton, ListItemText, Menu, MenuItem } from '@mui/material';
import { MdAccountCircle as UserMenuIcon, MdExitToApp as LogoutIcon } from 'react-icons/md';
import { appUserContext } from 'helpers/services';


let CustomerUserMenu = () => {
    let appUserService = useContext(appUserContext);

    let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    let handleOpen = (e: any) => {
        setAnchorEl(e.currentTarget);
    }

    let logout = async () => {
        setAnchorEl(null);
        await appUserService.signOut();
    }


    return (
        <>
            <List
                component="nav"
                disablePadding
            >
                <ListItemButton onClick={(e) => handleOpen(e)}>
                    <ListItemText primary={<UserMenuIcon />} />
                </ListItemButton>
            </List>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={anchorEl !== null}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem disabled>
                    {appUserService.currentUser?.firstName}&nbsp;{appUserService.currentUser?.lastName}<br />{appUserService.currentUser?.email}
                </MenuItem>
                <MenuItem onClick={logout}>
                    <LogoutIcon />&nbsp;&nbsp;Logout
                </MenuItem>
            </Menu>
        </>
    )
}

export default CustomerUserMenu;